import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import {
  IconSizeEnum, IProductFeatures, PositionEnum, SdButtonComponent, SdIconComponent, SdModalAsideComponent,
  SdTitleComponent
} from '@seb/web-design-system/core';

@Component({
  selector: 'sd-product-features',
  templateUrl: './product-features.component.html',
  styleUrls: ['./product-features.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdTitleComponent,
    SdIconComponent,
    SdModalAsideComponent,
    SdButtonComponent,
    NgTemplateOutlet
  ]
})
export class SdProductFeaturesComponent {
  @Input()
  productFeatures: IProductFeatures;

  @Input()
  isLoading: boolean;

  @Input()
  isOpened: boolean;

  iconSize = IconSizeEnum;
  positionEnum: PositionEnum.left | PositionEnum.right = PositionEnum.right;

  openModal(): void {
    this.isOpened = true;
  }
}
